import React from 'react';
import { EditOutlined } from '@ant-design/icons';
import CreateProductViaFormModal from 'common/components/product-add/CreateProductViaFormModal';
import messages from 'i18n/messages/home';
import { RibbonButton } from 'common/components';
import { useGlobalModal } from 'hooks';

function ProductEdit({ isDisabled, productId, buttonText }) {
  const { MODAL_NAMES, openModal } = useGlobalModal();

  return (
    <>
      <RibbonButton
        size='small'
        icon={<EditOutlined style={{ height: 26 }} />}
        label={buttonText || messages.productEdit}
        onClick={() => openModal(MODAL_NAMES.ADD_EDIT_PRODUCT_MODAL)}
        disabled={isDisabled}
        className='button-item-dropdown'
      />
      <CreateProductViaFormModal isEdit productId={productId} />
    </>
  );
}

export default ProductEdit;
